<template>
  <!-- A volta para o hub é o breadcrumb "Aprovações ›" do header (link), então a
       página não repete um "Voltar". -->
  <div class="w-full flex flex-col gap-6 text-left" :data-testid="`approvals-queue-${queue.key}`">
    <!-- `@vue:mounted`: roda depois do onMounted do módulo, inclusive na troca
         fila→fila sem remount desta página — módulos legados chamam setTitle
         sozinhos e sobrescreveriam o header com breadcrumb. -->
    <component :is="QUEUE_COMPONENTS[queue.key]" :key="queue.key" @vue:mounted="applyHeader" />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, watch } from 'vue'
import type { Component } from 'vue'
import { useRoute } from 'vue-router'

import PATHS from '@/router/paths'
import { useHeaderStore } from '@/pinia-store/useHeaderStore'

import HandoverApprovals from '../HandoverApprovals/Index.vue'
import AuditoriumExceptionalities from '../AuditoriumExceptionalities/index.vue'
import DsAttendance from '../DsAttendance/Index.vue'
import CheckValidation from '../CheckValidation/Index.vue'
import FacialBiometry from '../FacialBiometry/Index.vue'
import PriorityPayments from '../PriorityPayments/Index.vue'
import ProfessionalDocuments from '../ProfessionalDocuments/Index.vue'
import { findApprovalsQueue, isApprovalsQueueKey } from './queues'
import type { ApprovalsQueueKey } from './queues'

// Mesmo mapa slot→componente do antigo shell de abas (ApprovalsTabs.vue).
const QUEUE_COMPONENTS: Record<ApprovalsQueueKey, Component> = {
  handoverApprovals: HandoverApprovals,
  exceptionality: AuditoriumExceptionalities,
  attendance: DsAttendance,
  checkValidation: CheckValidation,
  facialBiometry: FacialBiometry,
  priorityPayments: PriorityPayments,
  professionalDocuments: ProfessionalDocuments
}

const route = useRoute()
const headerStore = useHeaderStore()

const queueKey = computed<ApprovalsQueueKey>(() => {
  const key = route.meta.approvalsQueue
  return isApprovalsQueueKey(key) ? key : 'exceptionality'
})

const queue = computed(() => findApprovalsQueue(queueKey.value))

const breadcrumb = { label: 'Aprovações', route: PATHS.APPROVALS }

// Header da fila (com breadcrumb). Aplicado no mount da página, na troca de
// fila e após o mount do módulo (ver `@vue:mounted` no template).
const applyHeader = () =>
  headerStore.setTitle(queue.value.pageTitle, queue.value.pageDescription, breadcrumb)

onMounted(applyHeader)
watch(queueKey, applyHeader)
</script>
